// Listings in these locations will have their listing cards redirect to the address page instead of opening a listing modal

export const locationsToNotUseListingModals = [
  'FL',
];
